// Import all lesson sets
import bashLessons from './lessons-bash';
import terraformLessons from './lessons-terraform';
import linuxLessons from './lessons-linux';
import gitLessons from './lessons-git';
import ansibleLessons from './lessons-ansible';
import dockerLessons from './lessons-docker';
import networkingLessons from './lessons-networking';
import vimLessons from './lessons-vim';

// Combine all lesson sets into one export
const lessonData = {
  bash: bashLessons,
  terraform: terraformLessons,
  linux: linuxLessons,
  git: gitLessons,
  ansible: ansibleLessons,
  docker: dockerLessons,
  networking: networkingLessons,
  vim: vimLessons
};

export default lessonData;
